/**
 * @ngdoc directives
 * @memberof mercury.modules.time
 * @name breakday
 * @attr break-start
 * @attr break-end
 */
angular.module('mercury.modules.time.roster')
.directive('breakday', ["reporttime", "$parse", function(reporttime, $parse) {
  return {
    restrict: 'A',
    scope: true,
    link: function(scope, element, attrs) {

      // Get the parent element so we can append the break to it when dragging
      var parentElement = element.parent();
      // Get the editor body so we can set the containment to it
      var editorBody = angular.element('#editor-container');
      // Define break time label
      var labelBreakTime = angular.element('<div class="drag-break-time-label"></div>');
      var labelBreakOverlap = angular.element('<div class="drag-break-error-label"></div>');

      // Get the break object from the parent scope
      var shiftBreak = $parse(attrs.break)(scope);

      // Checks for presence of touch events on the break element on the browser
      var isMobile = function() {
        return 'ontouchstart' in window || navigator.maxTouchPoints;
      };

      // Round the minutes to the nearest 5 minutes
      var roundMinutes = function(input) {
        var interval = 5;
        return Math.round(input / interval) * interval;
      };

      // Retrieve and store the break id so that it can be used later to check for overlaps.
      var breakID = shiftBreak.id;
      var dragDelay = isMobile() ? 500 : 0;
      var shiftStart = scope.shift.clockinTime;
      var shiftEnd = scope.shift.clockoutTime;
      var minutesInShift = moment(shiftEnd).diff(shiftStart, 'minutes');

      var breakLeftPosition = function(breakStart) {
          var breakStartMinutes = moment(breakStart).diff(shiftStart, 'minutes');
          var percentShiftStart = (breakStartMinutes / minutesInShift) * 100;
          return percentShiftStart + '%';
        };

      var breakWidth = function(breakStart, breakEnd) {
          var breakStartMoment = moment(breakStart);
          var breakEndMoment = moment(breakEnd);
          var breakLengthMinutes = breakEndMoment.diff(breakStartMoment, 'minutes');
          var percentDayLength = (breakLengthMinutes / minutesInShift) * 100;
          return percentDayLength + '%';
        };

      // the --shiftBgColor css variable is defined by the parent div via
      // it's role-N class - we then blend that with white to lighten things up
      // to overlay the standard shift background color
      var lighterColor = 'color-mix(in srgb, var(--shiftBgColor) 80%, white)';

      var background = function(isPaid) {
        return isPaid ?
        'repeating-linear-gradient(-45deg, var(--shiftBgColor), var(--shiftBgColor) 2px, ' + lighterColor + ' 2px, ' + lighterColor + ' 4px)' :
        lighterColor;
      };

      var setPosition = function() {
        element.css({
            'width': breakWidth(scope.break.breakStart, scope.break.breakEnd),
            'left': breakLeftPosition(scope.break.breakStart),
            'background': background(scope.break.paid),
            'top': '0px',
            'height': '100%'
          });
      };

      setPosition();

      // When the break start or end time changes, update the local scope variables used to calculate and set the element position.
      var resetShiftValues = function(flag, value) {
        switch (flag) {
          case 'clockoutTime':
            shiftEnd = value;
            minutesInShift = moment(shiftEnd).diff(shiftStart, 'minutes');
          break;
          case 'clockinTime':
            shiftStart = value;
            minutesInShift = moment(shiftEnd).diff(shiftStart, 'minutes');
          break;
          default:
          break;
        }
        setPosition();
      };

      // If the shifts clockin or out time changes, reset the position of the break.
      // This is needed because the break is positioned relative to the shift.
      scope.$watch('shift.clockinTime', function(newShiftStart) {
        resetShiftValues('clockinTime', newShiftStart);
      });
      scope.$watch('shift.clockoutTime', function(newEndtime) {
        resetShiftValues('clockoutTime', newEndtime);
      });
      scope.$watch('shift', function() {
        setPosition();
      });

      var removeLabels = function() {
        element.find('.drag-break-time-label').remove();
        element.find('.drag-break-error-label').remove();
      };

      // Check for overlapping breaks
      var breakOverlapCheck = function(newBreakStart, breakLength) {
        var overlapCheck = scope.shift.breaks.some(function(existingBreak) {
          if (existingBreak.id !== breakID) {
            var existingStart = moment(existingBreak.breakStart);
            var existingEnd = moment(existingBreak.breakEnd);
            var newBreakEnd = newBreakStart.clone().add(breakLength, 'minutes');

            // Check to see that new breaks don't overlap with existing as well as new breaks don't contain existing breaks and vice versa
            if (newBreakStart.isBetween(existingStart, existingEnd, null, '[]') ||
            newBreakEnd.isBetween(existingStart, existingEnd, null, '[]') ||
            existingStart.isBetween(newBreakStart, newBreakEnd, null, '[]') ||
            existingEnd.isBetween(newBreakStart, newBreakEnd, null, '[]')) {
              return true;
            }
          }
          return false;
        });

        return overlapCheck;
      };

      // calculate the break position in relation to the day element
      var breakPositionOffsetCalculator = function(ui) {
        // Get the dragged element (break element)
        var draggedElement = ui.helper;
        // Get the parent element (shift element)
        var shiftElement = draggedElement.parent();

        return ui.position.left + shiftElement.position().left;
      };

      /*
      * Configure the draggable break to enable moving on the day or to a different staff member.
      */
      element.draggable({
        grid: [1, element.height() + 11],
        revert: 'invalid',
        revertDuration: 0,
        containment: editorBody,
        delay: dragDelay,
        start: function() {
          jQuery('#editor-body').addClass('dragging');
        },
        stop: function() {
          jQuery('#editor-body').removeClass('dragging');
          // Remove the label element
          removeLabels();
          // Update the shift
          scope.updateShift(scope.shift);
          // Update the break element position
          setPosition();
          // Append the element back to the parent
          parentElement.append(element);
        },
        drag: function(event, ui) {
          event.stopPropagation();
          removeLabels();
          var breakObject = scope.shift.breaks.find(function(obj) {
            return obj.id === breakID;
          });

          // Calculate the offset of the dragged element relative to the day element
          var offsetLeftRelativeToDay = breakPositionOffsetCalculator(ui);
          var breakStartMoment = moment(breakObject.breakStart);
          var breakEndMoment = moment(breakObject.breakEnd);
          var breakLength = breakEndMoment.diff(breakStartMoment, 'minutes');
          var newStart = roundMinutes(1440 * (offsetLeftRelativeToDay / (angular.element(ui.helper).parent().parent().width())));
          var newBreakStart = moment(reporttime.start()).add(newStart, 'minutes');

          // Show the label with newBreakStart
          labelBreakTime.text(newBreakStart.format('HH:mm'));
          element.append(labelBreakTime);

          // Check for overlapping breaks
          var overlap = breakOverlapCheck(newBreakStart, breakLength);

          // Show the appropriate label for breaks that overlap
          if (overlap) {
            removeLabels();
            labelBreakOverlap.text('Break Overlap!');
            element.append(labelBreakOverlap);
          }

          // Set the break start and end times provided there is no overlap
          if (!overlap) {
            breakObject.breakStart = newBreakStart.format();
            breakObject.breakEnd = newBreakStart.add(breakLength, 'minutes').format();
          }
        }
      });

      /*
      * Configure the break element as a resizable element.
      * The resize length is contained by the shift length and the new resized length will be the new break length.
      */
      element.resizable({
        handles: 'e, w',
        containment: 'parent',
        distance: (Math.round((1440 / jQuery('.day-row').width()) * 15) / 2),
        start: function() {

        },
        stop: function() {
          // Remove the label element
          removeLabels();
          // Update the shift
          scope.updateShift(scope.shift);
          // Update the break element position
          setPosition();
          // Append the element back to the parent
          parentElement.append(element);
        },
        resize: function(event, ui) {
          event.stopPropagation();
          removeLabels();

          // Get the original break object
          var breakObject = scope.shift.breaks.find(function(obj) {
            return obj.id === breakID;
          });

          // Get the change in left position
          var deltaLeft = ui.position.left - ui.originalPosition.left;
          // Determine which handle is being dragged
          var handle = (deltaLeft === 0) ? 'right' : 'left';

          // Calculate the offset of the dragged element relative to the day element
          var offsetLeftRelativeToDay = breakPositionOffsetCalculator(ui);

          // Calculate the new break length and start and end time
          var newBreakLength = roundMinutes(Math.round(1440 * ((ui.size.width) / angular.element(ui.element).parent().parent().width())));
          var newBreakStartMinutes = roundMinutes(Math.round(1440 * (offsetLeftRelativeToDay / angular.element(ui.element).parent().parent().width())));
          var newBreakStart = moment(reporttime.start()).add(newBreakStartMinutes, 'minutes');
          var newBreakEnd = newBreakStart.clone().add(newBreakLength, 'minutes');

          // Check for overlapping breaks
          var overlap = breakOverlapCheck(newBreakStart, newBreakLength);

          if (handle === 'right') {
            // Show the label with newBreakEnd
            labelBreakTime.text(newBreakEnd.format('HH:mm'));
            element.append(labelBreakTime);

            // update the break end time
            if (!overlap) {
              breakObject.breakEnd = newBreakEnd.format();
            }

          } else {
            // Show the label with newBreakStart
            labelBreakTime.text(newBreakStart.format('HH:mm'));
            element.append(labelBreakTime);

            if (!overlap) {
              breakObject.breakStart = newBreakStart.format();
            }
          }

          // Show the appropriate label for breaks that overlap
          if (overlap) {
            removeLabels();
            labelBreakOverlap.text('Break Overlap!');
            element.append(labelBreakOverlap);
          }
        }
      });
    }
  };
}]);
